﻿export class ServiceResponse {
    constructor() {
    }
    public Version: string;
    public StatusCode: number;
    public Message: string;
    public Result: any;
    public Data: any;
}